export const isLoggedIn = () => fetch(process.env.REACT_APP_LOGIN_VERIFY_API, { credentials: 'include' });

export const getUserInfo = () => new Promise((resolve, reject) => {
  fetch(process.env.REACT_APP_USER_INFO_API, { credentials: 'include' })
    .then((response) => response.json())
    .then((json) => {
      resolve(json);
    })
    .catch((res) => {
      reject(res);
    });
});

export const submitInquiries = (payload) => new Promise((resolve, reject) => {
  fetch(process.env.REACT_APP_INQUIRIES_URL, {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'content-type': 'application/json',
    },
  }).then((response) => response.json())
    .then((json) => {
      resolve(json);
    })
    .catch((res) => {
      reject(res);
    });
});
